import { ICON_TYPES } from '../constants';

export const Redirect = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_688_4788)">
        <path
          d="M20 11V19C20 21.757 17.757 24 15 24H5C2.243 24 0 21.757 0 19V9C0 6.243 2.243 4 5 4H13C13.552 4 14 4.448 14 5C14 5.552 13.552 6 13 6H5C3.346 6 2 7.346 2 9V19C2 20.654 3.346 22 5 22H15C16.654 22 18 20.654 18 19V11C18 10.448 18.448 10 19 10C19.552 10 20 10.448 20 11ZM21 0H14C13.448 0 13 0.448 13 1C13 1.552 13.448 2 14 2H20.586L8.293 14.293C7.902 14.684 7.902 15.316 8.293 15.707C8.488 15.902 8.744 16 9 16C9.256 16 9.512 15.902 9.707 15.707L22 3.414V10C22 10.552 22.448 11 23 11C23.552 11 24 10.552 24 10V3C24 1.346 22.654 0 21 0Z"
          fill="#141414"
        />
      </g>
    </svg>
  );
};

Redirect.iconType = ICON_TYPES.REDIRECTS;
